/**
 * Configuration settings for S3 integration
 */

// API Base URL - could come from environment variables
export const API_BASE_URL = process.env.REACT_APP_DASHBOARD_SECURE_API;
// export const API_BASE_URL = "https://51b2-31-215-210-116.ngrok-free.app";

// Timeout for API requests in milliseconds
export const API_TIMEOUT = 30000;

// Max file size in bytes (10MB default)
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

// Number of retries for failed uploads
export const UPLOAD_RETRIES = 3;

// Enables verbose logging for debugging
export const DEBUG_MODE = process.env.NODE_ENV !== 'production';

/**
 * Logging utility that respects DEBUG_MODE setting
 */
export const log = {
  info: (...args) => DEBUG_MODE && console.info('[S3Integration]', ...args),
  error: (...args) => console.error('[S3Integration]', ...args),
  warn: (...args) => console.warn('[S3Integration]', ...args),
  debug: (...args) => DEBUG_MODE && console.debug('[S3Integration]', ...args)
}; 